import { MealForm } from "./components/MealForm";
import { useHash } from "./hooks/useHash";
import { TestRecipe } from "./Pages/GetRecipe";
import Refrigerator from "./Pages/Refrigerator";
import { ScanPage } from "./Pages/ScanPage";
import SignIn from "./Pages/SignIn";
import SignUp from "./Pages/SignUp";
import TopPageElement from "./Pages/TopPage";

export const Router = () => {
    const hash = useHash(window.location.hash);

    switch(hash) {
        case "":
            return <TopPageElement/>
        case "#GetRecipe":
            return <TestRecipe />
        case "#ScanPage":
            return <ScanPage />
        case "#Refrigerator":
            return <Refrigerator/>
        case "#SignIn":
            return <SignIn/>
        case "#SignUp":
            return <SignUp/>
        case "#TopPage":
            return <TopPageElement/>
        case "#MealForm":
            return <MealForm />
        default:
            return <h1>Not found</h1>
    }
}